<template>
    <div class="section">
        <mq-layout mq="tablet+">
            <button
                v-if="isAdmin"
                v-t="'project.add_content'"
                class="button is-pink-red has-shadow lb-floating-button_community zindex-1"
                @click="$emit('create')"
            />
            <app-buttons-filter
                :options="availableActivityTypes"
                :filter.sync="selectedFilter"
                class
            />
        </mq-layout>
        <mq-layout mq="mobile">
            <app-dropdown-filter
                :options="availableActivityTypes"
                :filter.sync="selectedFilter"
                :active="dropdownActive"
                :text="'Dashboard.show'"
                class="is-full-width pb-3"
                @click="dropdownActive = !dropdownActive"
            />
            <button
                v-if="isAdmin"
                v-t="'project.add_content'"
                class="button is-pink-red has-shadow"
                @click="$emit('create')"
            />
        </mq-layout>
        <draggable
            v-model="activities"
            :disabled="!canSort"
            class="columns pt-3 is-multiline"
            @end="updateActivitiesOrder"
        >
            <community-activity
                v-for="activity in activities"
                :key="activity._id"
                :content="activity"
                class="column is-6 is-3-widescreen"
                @delete="deleteActivity(activity._id)"
                @edit="$emit('edit', activity._id)"
                @toggleState="togglePublishState(activity)"
                @duplicate="duplicate(activity)"
                @move="openManagement(activity)"
            />
        </draggable>
        <community-activity-management
            v-if="showManagement"
            :activity="selectedActivity"
            @close="
                selectedActivity = undefined;
                showManagement = false;
            "
        />
    </div>
</template>
<script>
import CommunityActivity from '@/components/CommunityActivity';
import CommunityActivityManagement from '@/components/CommunityActivityManagement';
import AppButtonsFilter from '@/components/AppButtonsFilter';
import AppDropdownFilter from '@/components/AppDropdownFilter';
import _ from 'underscore';
import draggable from 'vuedraggable';
import { exitFolder } from '@/services/API';
export default {
    components: {
        CommunityActivity,
        AppButtonsFilter,
        AppDropdownFilter,
        draggable,
        CommunityActivityManagement,
    },
    beforeRouteLeave(to, from, next) {
        this.exited = true;
        this.registerExit();
        next();
    },
    props: {},
    data() {
        return {
            selectedFilter: this.$t('Constants.FILTER_OPTION_ACTIVITY_ALL'),
            activities: [],
            dropdownActive: false,
            showInputModal: false,
            fromClipboard: false,
            activityDraft: {
                _id: 'draft',
                accessLevel: 'administrator',
                owner: {},
                image: undefined,
                tags: [],
                title: undefined,
                description: undefined,
                area: undefined,
                type: undefined,
            },
            activityTags: [],
            exited: false,
            showManagement: false,
            selectedActivity: undefined,
        };
    },

    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        community() {
            return this.$store.getters.community;
        },
        isAdmin() {
            return this.community.accessLevel == 'administrator';
        },
        folder() {
            return _.findWhere(this.community.activityFolders, {
                _id: this.$route.params.id,
            });
        },
        communityActivities() {
            if (this.folder) {
                return this.folder.activities;
            } else {
                return [];
            }
        },
        availableActivityTypes() {
            return [
                ...[this.$t('Constants.FILTER_OPTION_ACTIVITY_ALL')],
                ..._.chain(this.communityActivities)
                    .pluck('area')
                    .invoke('toUpperCase')
                    .unique()
                    .map((type) => type)
                    .invoke('toLowerCase')
                    .value(),
            ];
        },
        activeFilter() {
            switch (this.selectedFilter) {
                case this.$t('Constants.FILTER_OPTION_ACTIVITY_ALL'):
                    return 'all';
                    break;
            }
            return this.selectedFilter;
        },
        communityActivityTags() {
            return this.$store.getters.communityActivityTags;
        },
        canSort() {
            return this.isAdmin && this.activeFilter === 'all';
        },
        windowSize() {
            return this.$mq;
        },
    },
    watch: {
        selectedFilter: {
            handler: 'filterHandler',
            immediate: true,
        },
        communityActivities() {
            this.activities = this.folder.activities;
        },
    },
    created() {
        window.addEventListener('beforeunload', this.registerExit);
    },
    beforeDestroy() {
        // this is not called on router change.
        if (false === this.exited) {
            this.registerExit();
        }
        //this.eventSource.close();
        window.removeEventListener('beforeunload', this.registerExit);
    },
    mounted() {
        this.$store.commit('CLEAR_PENDING_ACTIVITIES', this.$route.params.id);
    },
    methods: {
        filterHandler() {
            if (this.activeFilter !== 'all') {
                this.activities = this.communityActivities.filter((item) => {
                    if (
                        item.area.toUpperCase() ===
                        this.selectedFilter.toUpperCase()
                    ) {
                        return item;
                    }
                });
            } else {
                this.activities = this.communityActivities;
            }
        },
        updateActivitiesOrder() {
            if (this.activeFilter === 'all') {
                let folderToUpdate = this.folder;
                folderToUpdate.activities = this.activities;
                this.$store.dispatch('updateActivityFolder', {
                    object: folderToUpdate,
                    id: this.community._id,
                });
            }
        },
        async deleteActivity(_id) {
            if (_id == 'draft') {
                return this.cancelInput();
            }
            if (confirm(this.$t('delete_project_confirmation_message'))) {
                this.$store.dispatch('deleteActivity', {
                    communityId: this.$route.params.communityId,
                    activityId: _id,
                });
                /*this.activities = this.community.activities.filter(function(item) {
          return item["_id"] != _id;
        });*/
            }
        },
        togglePublishState(content) {
            const methodToDispatch = content.published
                ? 'unpublishActivity'
                : 'publishActivity';
            this.$store
                .dispatch(methodToDispatch, {
                    communityId: this.$route.params.communityId,
                    activityId: content._id,
                })
                .then(() => {
                    content.published = !content.published;
                })
                .catch((e) => {
                    console.error('error', methodToDispatch, e);
                    alert(e);
                });
        },
        duplicate(content) {
            this.$store
                .dispatch('duplicateActivity', {
                    communityId: this.$route.params.communityId,
                    activity: content,
                })
                .then((data) => {
                    console.log('duplicated');
                })
                .catch((e) => {
                    console.error('error in duplicate', e);
                    alert(e);
                });
        },

        openManagement(activity) {
            this.selectedActivity = activity;
            this.showManagement = true;
        },
        registerExit() {
            const lastActivity = _.last(this.activities);
            if (_.isEmpty(lastActivity)) {
                return;
            }
            exitFolder(lastActivity.folder, this.community._id);
        },
    },
};
</script>

<style scoped>
.is-full-width {
    display: block;
    margin-left: 1rem;
    margin-right: 1rem;
}
.is-full-width button {
    width: 100%;
}
.is-full-width .dropdown-menu {
    width: 100%;
    text-align: center;
}

.clear-buttons .lb-button {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}

.clear-buttons .lb-button.is-light {
    color: grey;
    background-color: white;
}
.lb-floating-button_community {
    position: absolute;
    top: 1.5rem;
    right: 2rem;
}
.lb-top-button_community {
    position: relative;
    margin: 1rem;
    display: block;
}
.lb-top-button_community {
    position: relative;
    margin: 1rem;
    display: block;
}
.zindex-1{
    z-index: 1;
}
</style>
